var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"button"},_vm.$listeners),[_c('img',{attrs:{"src":require("@/assets/img/play-button.png"),"alt":"play"}})])}
var staticRenderFns = []

export { render, staticRenderFns }